import React from "react";
import { DatePicker, Form, Input, TimePicker, Select, InputNumber } from "antd";
import classNames from "classnames";
import InfoBox from "../../molecules/InfoBox";
import { getFormFieldData } from "../../../system/helpers/helpfulFunctions";

const AntField = (AntComponent) => ({
  field,
  form,
  label,
  tooltip,
  selectOptions,
  submitCount,
  lang,
  validationByLang,
  infoBoxMsg,
  infoBoxClassName,
  ...props
}) => {
  const touched = getFormFieldData(form.touched, field.name);
  const submitted = submitCount > 0;
  const hasError =
    validationByLang && !!lang
      ? getFormFieldData(form.errors, field.name)?.[lang]
      : getFormFieldData(form.errors, field.name);
  const submittedError = hasError && submitted;
  const touchedError = hasError && touched;
  const onBlur = () => form.setFieldTouched(field.name, true);
  return (
    <Form.Item
      label={label}
      tooltip={tooltip}
      labelAlign="left"
      help={submittedError || touchedError ? hasError : false}
      validateStatus={submittedError || touchedError ? "error" : "success"}
    >
      <AntComponent {...field} {...props} onBlur={onBlur}>
        {selectOptions &&
          selectOptions.map((name) => (
            <Select.Option key={name} value={name}>
              {name}
            </Select.Option>
          ))}
      </AntComponent>
      {infoBoxMsg && (
        <InfoBox
          message={infoBoxMsg}
          className={classNames("top-margin", infoBoxClassName)}
        />
      )}
    </Form.Item>
  );
};

export const AntInput = AntField(Input);
export const AntInputPassword = AntField(Input.Password);
export const AntSelect = AntField(Select);
export const AntInputNumber = AntField(InputNumber);
export const AntDatePicker = AntField(DatePicker);
export const AntTimePicker = AntField(TimePicker);
export const AntTextarea = AntField(Input.TextArea);
